import React from "react";
import EAModal from "../../shared/Modal/EAModal";
import { useTranslation } from "react-i18next";
import EADivider from "../../shared/EADivider";
import CalendarPass from "../CalendarPass";
import { AssortGroup } from "../../../models/AssortGroup";
import EAButton from "../../shared/Buttons/EAButton";
import { BsBasket3 } from "react-icons/bs";

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  pass: AssortGroup;
  selectedDate: Date;
  setDateBetween: (date: Date) => void;
  onAddToBasket: () => void;
}

const PassModal: React.FC<IProps> = ({ isOpen, onClose, pass, selectedDate, setDateBetween, onAddToBasket }) => {
  const { t } = useTranslation();
  return (
    <EAModal isOpen={isOpen} title="" onClose={onClose} hideButtons>
      <div className="pass-modal-container">
        <div className="pass-modal-block pass-modal-product-info">
          <img alt="Miniatura zdjęcia produktu" src={pass.picture} />
          <h4>{pass.name}</h4>
          <p dangerouslySetInnerHTML={{ __html: pass.description }}></p>
        </div>

        <div className="pass-modal-block pass-modal-date-choice">
          <h5>{t("wybierz_date_rozpoczecia")}</h5>
          <EADivider />
          <CalendarPass selectedDate={selectedDate} setDateBetween={setDateBetween} item={pass} />
          <div className="pass-modal-button">
            <EAButton title={t("dodaj_do_koszyka")} endIcon={<BsBasket3 />} onClick={onAddToBasket} fullWidth />
          </div>
        </div>
      </div>
    </EAModal>
  );
};

export default PassModal;
